module.exports = __webpack_public_path__ + "img/first_down_failed.798bb681.jpg";